import { Box } from 'grommet';
import React from 'react';
const PageWrapper = (props) => {
    const { children } = props;
    return (React.createElement(Box, { fill: true, justify: "start", align: "center", background: "background-back" },
        React.createElement(Box, { fill: "vertical", background: "background", width: "xlarge", pad: "none" }, children)));
};
PageWrapper.displayName = 'PageWrapper';
export default PageWrapper;
